/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {optionsTransformer} from '@sekoia/shared/requests/nswagBaseClients/baseClient';
import * as moment from 'moment';

export class BaseClient {
  getBaseUrl(_: string, parsedBaseUrl: string | undefined): string {
    if (parsedBaseUrl) {
      return parsedBaseUrl;
    }

    if (!process.env.HEALTH_MEASUREMENTS_SERVICE_URL) {
      throw new Error('HEALTH_MEASUREMENTS_SERVICE_URL must be set in environment');
    }

    return process.env.HEALTH_MEASUREMENTS_SERVICE_URL;
  }
  
  async transformOptions(options: RequestInit) : Promise<RequestInit> {
    return optionsTransformer.addDefaultHeaders(options);
  }
}

export class RespiratoryRateClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-healthmeasurements-dev.sekoia.one", baseUrl);
    }

    getRespiratoryRateMeasurements(residentId: string | null, from: moment.Moment | undefined, to: moment.Moment | undefined, includeDeleted: boolean | undefined): Promise<RespiratoryRateResponse[]> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/respiratoryrate?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "IncludeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRespiratoryRateMeasurements(_response);
        });
    }

    protected processGetRespiratoryRateMeasurements(response: Response): Promise<RespiratoryRateResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RespiratoryRateResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RespiratoryRateResponse[]>(<any>null);
    }

    registerRespiratoryRate(residentId: string | null, registerBodyTemperatureRequest: RegisterRespiratoryRateRequest): Promise<RegisterRespiratoryRateResponse> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/respiratoryrate";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registerBodyTemperatureRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegisterRespiratoryRate(_response);
        });
    }

    protected processRegisterRespiratoryRate(response: Response): Promise<RegisterRespiratoryRateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RegisterRespiratoryRateResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegisterRespiratoryRateResponse>(<any>null);
    }

    deleteRespiratoryRateMeasurement(residentId: string | null, id: string, deleteRequest: DeleteRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/respiratoryrate/{id}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRespiratoryRateMeasurement(_response);
        });
    }

    protected processDeleteRespiratoryRateMeasurement(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class OxygenSaturationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-healthmeasurements-dev.sekoia.one", baseUrl);
    }

    registerOxygenSaturation(residentId: string | null, registerOxygenSaturationRequest: RegisterOxygenSaturationRequest): Promise<RegisterOxygenSaturationResponse> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/oxygensaturation";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registerOxygenSaturationRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegisterOxygenSaturation(_response);
        });
    }

    protected processRegisterOxygenSaturation(response: Response): Promise<RegisterOxygenSaturationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RegisterOxygenSaturationResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegisterOxygenSaturationResponse>(<any>null);
    }

    getOxygenSaturationMeasurements(residentId: string | null, from: moment.Moment | undefined, to: moment.Moment | undefined, includeDeleted: boolean | undefined): Promise<OxygenSaturationResponse[]> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/oxygensaturation?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "IncludeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOxygenSaturationMeasurements(_response);
        });
    }

    protected processGetOxygenSaturationMeasurements(response: Response): Promise<OxygenSaturationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OxygenSaturationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OxygenSaturationResponse[]>(<any>null);
    }

    deleteOxygenSaturationMeasurement(residentId: string | null, id: string, deleteRequest: DeleteRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/oxygensaturation/{id}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteOxygenSaturationMeasurement(_response);
        });
    }

    protected processDeleteOxygenSaturationMeasurement(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class MeasurementTypeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-healthmeasurements-dev.sekoia.one", baseUrl);
    }

    updateMeasurementType(type: string | null, request: UpdateMeasurementTypeRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/measurementtypes/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMeasurementType(_response);
        });
    }

    protected processUpdateMeasurementType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getMeasurementTypes(): Promise<MeasurementTypeResponse[]> {
        let url_ = this.baseUrl + "/api/measurementtypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMeasurementTypes(_response);
        });
    }

    protected processGetMeasurementTypes(response: Response): Promise<MeasurementTypeResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasurementTypeResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeasurementTypeResponse[]>(<any>null);
    }
}

export class HeightClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-healthmeasurements-dev.sekoia.one", baseUrl);
    }

    registerHeight(residentId: string | null, registerHeightRequest: RegisterHeightRequest): Promise<HeightResponse> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/height";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registerHeightRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegisterHeight(_response);
        });
    }

    protected processRegisterHeight(response: Response): Promise<HeightResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = HeightResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HeightResponse>(<any>null);
    }

    getHeightMeasurements(residentId: string | null, from: moment.Moment | undefined, to: moment.Moment | undefined, includeDeleted: boolean | undefined): Promise<HeightResponse[]> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/height?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "IncludeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHeightMeasurements(_response);
        });
    }

    protected processGetHeightMeasurements(response: Response): Promise<HeightResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HeightResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HeightResponse[]>(<any>null);
    }

    deleteHeightMeasurement(residentId: string | null, id: string, deleteRequest: DeleteRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/height/{id}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteHeightMeasurement(_response);
        });
    }

    protected processDeleteHeightMeasurement(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class HeartRateClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-healthmeasurements-dev.sekoia.one", baseUrl);
    }

    registerHeartRate(residentId: string | null, registerHeartRateRequest: RegisterHeartRateRequest): Promise<RegisterHeartRateResponse> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/heartrate";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registerHeartRateRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegisterHeartRate(_response);
        });
    }

    protected processRegisterHeartRate(response: Response): Promise<RegisterHeartRateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RegisterHeartRateResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegisterHeartRateResponse>(<any>null);
    }

    getHeartRateMeasurements(residentId: string | null, from: moment.Moment | undefined, to: moment.Moment | undefined, includeDeleted: boolean | undefined): Promise<HeartRateResponse[]> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/heartrate?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "IncludeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHeartRateMeasurements(_response);
        });
    }

    protected processGetHeartRateMeasurements(response: Response): Promise<HeartRateResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HeartRateResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HeartRateResponse[]>(<any>null);
    }

    deleteHeartRateMeasurement(residentId: string | null, id: string, deleteRequest: DeleteRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/heartrate/{id}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteHeartRateMeasurement(_response);
        });
    }

    protected processDeleteHeartRateMeasurement(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class HealthMeasurementClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-healthmeasurements-dev.sekoia.one", baseUrl);
    }

    getLatestHealthMeasurement(residentId: string | null): Promise<MeasurementResponse[]> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/latest";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLatestHealthMeasurement(_response);
        });
    }

    protected processGetLatestHealthMeasurement(response: Response): Promise<MeasurementResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MeasurementResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MeasurementResponse[]>(<any>null);
    }
}

export class BodyWeightClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-healthmeasurements-dev.sekoia.one", baseUrl);
    }

    registerBodyWeight(residentId: string | null, request: RegisterBodyWeightRequest): Promise<RegisterBodyWeightResponse> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/bodyweight";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegisterBodyWeight(_response);
        });
    }

    protected processRegisterBodyWeight(response: Response): Promise<RegisterBodyWeightResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RegisterBodyWeightResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegisterBodyWeightResponse>(<any>null);
    }

    getBodyWeightMeasurements(residentId: string | null, from: moment.Moment | undefined, to: moment.Moment | undefined, includeDeleted: boolean | undefined): Promise<BodyWeightResponse[]> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/bodyweight?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "IncludeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBodyWeightMeasurements(_response);
        });
    }

    protected processGetBodyWeightMeasurements(response: Response): Promise<BodyWeightResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BodyWeightResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BodyWeightResponse[]>(<any>null);
    }

    deleteBodyWeight(residentId: string | null, id: string, deleteRequest: DeleteRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/bodyweight/{id}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteBodyWeight(_response);
        });
    }

    protected processDeleteBodyWeight(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class BodyTemperatureClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-healthmeasurements-dev.sekoia.one", baseUrl);
    }

    registerBodyTemperature(residentId: string | null, registerBodyTemperatureRequest: RegisterBodyTemperatureRequest): Promise<RegisterBodyTemperatureResponse> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/bodytemperature";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registerBodyTemperatureRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegisterBodyTemperature(_response);
        });
    }

    protected processRegisterBodyTemperature(response: Response): Promise<RegisterBodyTemperatureResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RegisterBodyTemperatureResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegisterBodyTemperatureResponse>(<any>null);
    }

    getBodyTemperatureMeasurements(residentId: string | null, from: moment.Moment | undefined, to: moment.Moment | undefined, includeDeleted: boolean | undefined): Promise<BodyTemperatureResponse[]> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/bodytemperature?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "IncludeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBodyTemperatureMeasurements(_response);
        });
    }

    protected processGetBodyTemperatureMeasurements(response: Response): Promise<BodyTemperatureResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BodyTemperatureResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BodyTemperatureResponse[]>(<any>null);
    }

    deleteBodyTemperatureMeasurement(residentId: string | null, id: string, deleteRequest: DeleteRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/bodytemperature/{id}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteBodyTemperatureMeasurement(_response);
        });
    }

    protected processDeleteBodyTemperatureMeasurement(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class BloodPressureClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-healthmeasurements-dev.sekoia.one", baseUrl);
    }

    registerBloodPressure(residentId: string | null, registerBloodPressureRequest: RegisterBloodPressureRequest): Promise<RegisterBloodPressureResponse> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/bloodpressure";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registerBloodPressureRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegisterBloodPressure(_response);
        });
    }

    protected processRegisterBloodPressure(response: Response): Promise<RegisterBloodPressureResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RegisterBloodPressureResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegisterBloodPressureResponse>(<any>null);
    }

    getBloodPressureMeasurements(residentId: string | null, from: moment.Moment | undefined, to: moment.Moment | undefined, includeDeleted: boolean | undefined): Promise<BloodPressureResponse[]> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/bloodpressure?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "IncludeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBloodPressureMeasurements(_response);
        });
    }

    protected processGetBloodPressureMeasurements(response: Response): Promise<BloodPressureResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BloodPressureResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodPressureResponse[]>(<any>null);
    }

    deleteBloodPressureMeasurement(residentId: string | null, id: string, deleteRequest: DeleteRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/bloodpressure/{id}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteBloodPressureMeasurement(_response);
        });
    }

    protected processDeleteBloodPressureMeasurement(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class BloodGlucoseClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-healthmeasurements-dev.sekoia.one", baseUrl);
    }

    registerBloodGlucose(residentId: string | null, registerBloodGlucoseRequest: RegisterBloodGlucoseRequest): Promise<RegisterBloodGlucoseResponse> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/bloodglucose";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registerBloodGlucoseRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegisterBloodGlucose(_response);
        });
    }

    protected processRegisterBloodGlucose(response: Response): Promise<RegisterBloodGlucoseResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = RegisterBloodGlucoseResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegisterBloodGlucoseResponse>(<any>null);
    }

    getBloodGlucoseMeasurements(residentId: string | null, from: moment.Moment | undefined, to: moment.Moment | undefined, includeDeleted: boolean | undefined): Promise<BloodGlucoseResponse[]> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/bloodglucose?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&";
        if (includeDeleted === null)
            throw new Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "IncludeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBloodGlucoseMeasurements(_response);
        });
    }

    protected processGetBloodGlucoseMeasurements(response: Response): Promise<BloodGlucoseResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BloodGlucoseResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BloodGlucoseResponse[]>(<any>null);
    }

    deleteBloodGlucoseMeasurement(residentId: string | null, id: string, deleteRequest: DeleteRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/resident/{residentId}/healthmeasurements/bloodglucose/{id}";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteBloodGlucoseMeasurement(_response);
        });
    }

    protected processDeleteBloodGlucoseMeasurement(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class MeasurementResponse implements IMeasurementResponse {
    causeForDeletion?: string | null;
    deleted!: boolean;
    deletedAt?: moment.Moment | null;
    deletedByEmployee?: string | null;
    createdBy!: string;
    id!: string;
    measuredAt!: moment.Moment;
    residentId!: string;
    type!: MeasurementTypes;

    protected _discriminator: string;

    constructor(data?: IMeasurementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "MeasurementResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.causeForDeletion = _data["causeForDeletion"] !== undefined ? _data["causeForDeletion"] : <any>null;
            this.deleted = _data["deleted"] !== undefined ? _data["deleted"] : <any>null;
            this.deletedAt = _data["deletedAt"] ? moment(_data["deletedAt"].toString()) : <any>null;
            this.deletedByEmployee = _data["deletedByEmployee"] !== undefined ? _data["deletedByEmployee"] : <any>null;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.measuredAt = _data["measuredAt"] ? moment(_data["measuredAt"].toString()) : <any>null;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): MeasurementResponse {
        data = typeof data === 'object' ? data : {};
        if (data["swagger_discriminator"] === "RespiratoryRateResponse") {
            let result = new RespiratoryRateResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "OxygenSaturationResponse") {
            let result = new OxygenSaturationResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "HeightResponse") {
            let result = new HeightResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "HeartRateResponse") {
            let result = new HeartRateResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BodyWeightResponse") {
            let result = new BodyWeightResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BodyTemperatureResponse") {
            let result = new BodyTemperatureResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BloodPressureResponse") {
            let result = new BloodPressureResponse();
            result.init(data);
            return result;
        }
        if (data["swagger_discriminator"] === "BloodGlucoseResponse") {
            let result = new BloodGlucoseResponse();
            result.init(data);
            return result;
        }
        let result = new MeasurementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["swagger_discriminator"] = this._discriminator; 
        data["causeForDeletion"] = this.causeForDeletion !== undefined ? this.causeForDeletion : <any>null;
        data["deleted"] = this.deleted !== undefined ? this.deleted : <any>null;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>null;
        data["deletedByEmployee"] = this.deletedByEmployee !== undefined ? this.deletedByEmployee : <any>null;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["measuredAt"] = this.measuredAt ? this.measuredAt.toISOString() : <any>null;
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data; 
    }
}

export interface IMeasurementResponse {
    causeForDeletion?: string | null;
    deleted: boolean;
    deletedAt?: moment.Moment | null;
    deletedByEmployee?: string | null;
    createdBy: string;
    id: string;
    measuredAt: moment.Moment;
    residentId: string;
    type: MeasurementTypes;
}

export class RespiratoryRateResponse extends MeasurementResponse implements IRespiratoryRateResponse {
    rate!: number;

    constructor(data?: IRespiratoryRateResponse) {
        super(data);
        this._discriminator = "RespiratoryRateResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rate = _data["rate"] !== undefined ? _data["rate"] : <any>null;
        }
    }

    static fromJS(data: any): RespiratoryRateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RespiratoryRateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate !== undefined ? this.rate : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IRespiratoryRateResponse extends IMeasurementResponse {
    rate: number;
}

export enum MeasurementTypes {
    RespiratoryRate = "RespiratoryRate",
    BodyTemperature = "BodyTemperature",
    HeartRate = "HeartRate",
    BodyWeight = "BodyWeight",
    BloodGlucose = "BloodGlucose",
    BloodPressure = "BloodPressure",
    OxygenSaturation = "OxygenSaturation",
    Height = "Height",
}

export class BodyTemperatureResponse extends MeasurementResponse implements IBodyTemperatureResponse {
    temperature!: number;

    constructor(data?: IBodyTemperatureResponse) {
        super(data);
        this._discriminator = "BodyTemperatureResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.temperature = _data["temperature"] !== undefined ? _data["temperature"] : <any>null;
        }
    }

    static fromJS(data: any): BodyTemperatureResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BodyTemperatureResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temperature"] = this.temperature !== undefined ? this.temperature : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IBodyTemperatureResponse extends IMeasurementResponse {
    temperature: number;
}

export class HeartRateResponse extends MeasurementResponse implements IHeartRateResponse {
    rate!: number;

    constructor(data?: IHeartRateResponse) {
        super(data);
        this._discriminator = "HeartRateResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rate = _data["rate"] !== undefined ? _data["rate"] : <any>null;
        }
    }

    static fromJS(data: any): HeartRateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HeartRateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate !== undefined ? this.rate : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IHeartRateResponse extends IMeasurementResponse {
    rate: number;
}

export class BodyWeightResponse extends MeasurementResponse implements IBodyWeightResponse {
    weight!: number;

    constructor(data?: IBodyWeightResponse) {
        super(data);
        this._discriminator = "BodyWeightResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.weight = _data["weight"] !== undefined ? _data["weight"] : <any>null;
        }
    }

    static fromJS(data: any): BodyWeightResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BodyWeightResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weight"] = this.weight !== undefined ? this.weight : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IBodyWeightResponse extends IMeasurementResponse {
    weight: number;
}

export class BloodGlucoseResponse extends MeasurementResponse implements IBloodGlucoseResponse {
    level!: number;

    constructor(data?: IBloodGlucoseResponse) {
        super(data);
        this._discriminator = "BloodGlucoseResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.level = _data["level"] !== undefined ? _data["level"] : <any>null;
        }
    }

    static fromJS(data: any): BloodGlucoseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BloodGlucoseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level !== undefined ? this.level : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IBloodGlucoseResponse extends IMeasurementResponse {
    level: number;
}

export class BloodPressureResponse extends MeasurementResponse implements IBloodPressureResponse {
    diastolic!: number;
    systolic!: number;

    constructor(data?: IBloodPressureResponse) {
        super(data);
        this._discriminator = "BloodPressureResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.diastolic = _data["diastolic"] !== undefined ? _data["diastolic"] : <any>null;
            this.systolic = _data["systolic"] !== undefined ? _data["systolic"] : <any>null;
        }
    }

    static fromJS(data: any): BloodPressureResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BloodPressureResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diastolic"] = this.diastolic !== undefined ? this.diastolic : <any>null;
        data["systolic"] = this.systolic !== undefined ? this.systolic : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IBloodPressureResponse extends IMeasurementResponse {
    diastolic: number;
    systolic: number;
}

export class OxygenSaturationResponse extends MeasurementResponse implements IOxygenSaturationResponse {
    level!: number;

    constructor(data?: IOxygenSaturationResponse) {
        super(data);
        this._discriminator = "OxygenSaturationResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.level = _data["level"] !== undefined ? _data["level"] : <any>null;
        }
    }

    static fromJS(data: any): OxygenSaturationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OxygenSaturationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level !== undefined ? this.level : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IOxygenSaturationResponse extends IMeasurementResponse {
    level: number;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions!: { [key: string]: any; };

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
            else {
                this.extensions = <any>null;
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = this.extensions[key] !== undefined ? this.extensions[key] : <any>null;
            }
        }
        return data; 
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions: { [key: string]: any; };
}

export class DeleteRequest implements IDeleteRequest {
    causeForDeletion!: string;

    constructor(data?: IDeleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.causeForDeletion = _data["causeForDeletion"] !== undefined ? _data["causeForDeletion"] : <any>null;
        }
    }

    static fromJS(data: any): DeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["causeForDeletion"] = this.causeForDeletion !== undefined ? this.causeForDeletion : <any>null;
        return data; 
    }
}

export interface IDeleteRequest {
    causeForDeletion: string;
}

export class RegisterMeasurementResponse implements IRegisterMeasurementResponse {
    measuredAt!: moment.Moment;
    residentId!: string;
    id!: string;

    constructor(data?: IRegisterMeasurementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measuredAt = _data["measuredAt"] ? moment(_data["measuredAt"].toString()) : <any>null;
            this.residentId = _data["residentId"] !== undefined ? _data["residentId"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): RegisterMeasurementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterMeasurementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measuredAt"] = this.measuredAt ? this.measuredAt.toISOString() : <any>null;
        data["residentId"] = this.residentId !== undefined ? this.residentId : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data; 
    }
}

export interface IRegisterMeasurementResponse {
    measuredAt: moment.Moment;
    residentId: string;
    id: string;
}

export class RegisterRespiratoryRateResponse extends RegisterMeasurementResponse implements IRegisterRespiratoryRateResponse {
    rate!: number;

    constructor(data?: IRegisterRespiratoryRateResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rate = _data["rate"] !== undefined ? _data["rate"] : <any>null;
        }
    }

    static fromJS(data: any): RegisterRespiratoryRateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterRespiratoryRateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate !== undefined ? this.rate : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IRegisterRespiratoryRateResponse extends IRegisterMeasurementResponse {
    rate: number;
}

export abstract class RegisterMeasurementRequest implements IRegisterMeasurementRequest {
    measuredAt!: moment.Moment;
    employeesToNotify!: string[];

    constructor(data?: IRegisterMeasurementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.employeesToNotify = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.measuredAt = _data["measuredAt"] ? moment(_data["measuredAt"].toString()) : <any>null;
            if (Array.isArray(_data["employeesToNotify"])) {
                this.employeesToNotify = [] as any;
                for (let item of _data["employeesToNotify"])
                    this.employeesToNotify!.push(item);
            }
            else {
                this.employeesToNotify = <any>null;
            }
        }
    }

    static fromJS(data: any): RegisterMeasurementRequest {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RegisterMeasurementRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measuredAt"] = this.measuredAt ? this.measuredAt.toISOString() : <any>null;
        if (Array.isArray(this.employeesToNotify)) {
            data["employeesToNotify"] = [];
            for (let item of this.employeesToNotify)
                data["employeesToNotify"].push(item);
        }
        return data; 
    }
}

export interface IRegisterMeasurementRequest {
    measuredAt: moment.Moment;
    employeesToNotify: string[];
}

export class RegisterRespiratoryRateRequest extends RegisterMeasurementRequest implements IRegisterRespiratoryRateRequest {
    rate!: number;

    constructor(data?: IRegisterRespiratoryRateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rate = _data["rate"] !== undefined ? _data["rate"] : <any>null;
        }
    }

    static fromJS(data: any): RegisterRespiratoryRateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterRespiratoryRateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate !== undefined ? this.rate : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IRegisterRespiratoryRateRequest extends IRegisterMeasurementRequest {
    rate: number;
}

export class RegisterOxygenSaturationResponse extends RegisterMeasurementResponse implements IRegisterOxygenSaturationResponse {
    level!: number;

    constructor(data?: IRegisterOxygenSaturationResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.level = _data["level"] !== undefined ? _data["level"] : <any>null;
        }
    }

    static fromJS(data: any): RegisterOxygenSaturationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOxygenSaturationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level !== undefined ? this.level : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IRegisterOxygenSaturationResponse extends IRegisterMeasurementResponse {
    level: number;
}

export class RegisterOxygenSaturationRequest extends RegisterMeasurementRequest implements IRegisterOxygenSaturationRequest {
    level!: number;

    constructor(data?: IRegisterOxygenSaturationRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.level = _data["level"] !== undefined ? _data["level"] : <any>null;
        }
    }

    static fromJS(data: any): RegisterOxygenSaturationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOxygenSaturationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level !== undefined ? this.level : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IRegisterOxygenSaturationRequest extends IRegisterMeasurementRequest {
    level: number;
}

export class UpdateMeasurementTypeRequest implements IUpdateMeasurementTypeRequest {
    accessControlTagIds!: string[];

    constructor(data?: IUpdateMeasurementTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            else {
                this.accessControlTagIds = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateMeasurementTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMeasurementTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        return data; 
    }
}

export interface IUpdateMeasurementTypeRequest {
    accessControlTagIds: string[];
}

export class MeasurementTypeResponse implements IMeasurementTypeResponse {
    type!: MeasurementTypes;
    accessControlTagIds!: string[];

    constructor(data?: IMeasurementTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            else {
                this.accessControlTagIds = <any>null;
            }
        }
    }

    static fromJS(data: any): MeasurementTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MeasurementTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        return data; 
    }
}

export interface IMeasurementTypeResponse {
    type: MeasurementTypes;
    accessControlTagIds: string[];
}

export class HeightResponse extends MeasurementResponse implements IHeightResponse {
    heightValue!: number;

    constructor(data?: IHeightResponse) {
        super(data);
        this._discriminator = "HeightResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.heightValue = _data["heightValue"] !== undefined ? _data["heightValue"] : <any>null;
        }
    }

    static fromJS(data: any): HeightResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HeightResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heightValue"] = this.heightValue !== undefined ? this.heightValue : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IHeightResponse extends IMeasurementResponse {
    heightValue: number;
}

export class RegisterHeightRequest extends RegisterMeasurementRequest implements IRegisterHeightRequest {
    heightValue!: number;

    constructor(data?: IRegisterHeightRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.heightValue = _data["heightValue"] !== undefined ? _data["heightValue"] : <any>null;
        }
    }

    static fromJS(data: any): RegisterHeightRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterHeightRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["heightValue"] = this.heightValue !== undefined ? this.heightValue : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IRegisterHeightRequest extends IRegisterMeasurementRequest {
    heightValue: number;
}

export class RegisterHeartRateResponse extends RegisterMeasurementResponse implements IRegisterHeartRateResponse {
    rate!: number;

    constructor(data?: IRegisterHeartRateResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rate = _data["rate"] !== undefined ? _data["rate"] : <any>null;
        }
    }

    static fromJS(data: any): RegisterHeartRateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterHeartRateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate !== undefined ? this.rate : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IRegisterHeartRateResponse extends IRegisterMeasurementResponse {
    rate: number;
}

export class RegisterHeartRateRequest extends RegisterMeasurementRequest implements IRegisterHeartRateRequest {
    rate!: number;

    constructor(data?: IRegisterHeartRateRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rate = _data["rate"] !== undefined ? _data["rate"] : <any>null;
        }
    }

    static fromJS(data: any): RegisterHeartRateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterHeartRateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rate"] = this.rate !== undefined ? this.rate : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IRegisterHeartRateRequest extends IRegisterMeasurementRequest {
    rate: number;
}

export class RegisterBodyWeightResponse extends RegisterMeasurementResponse implements IRegisterBodyWeightResponse {
    weight!: number;

    constructor(data?: IRegisterBodyWeightResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.weight = _data["weight"] !== undefined ? _data["weight"] : <any>null;
        }
    }

    static fromJS(data: any): RegisterBodyWeightResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterBodyWeightResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weight"] = this.weight !== undefined ? this.weight : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IRegisterBodyWeightResponse extends IRegisterMeasurementResponse {
    weight: number;
}

export class RegisterBodyWeightRequest extends RegisterMeasurementRequest implements IRegisterBodyWeightRequest {
    weight!: number;

    constructor(data?: IRegisterBodyWeightRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.weight = _data["weight"] !== undefined ? _data["weight"] : <any>null;
        }
    }

    static fromJS(data: any): RegisterBodyWeightRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterBodyWeightRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weight"] = this.weight !== undefined ? this.weight : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IRegisterBodyWeightRequest extends IRegisterMeasurementRequest {
    weight: number;
}

export class RegisterBodyTemperatureResponse extends RegisterMeasurementResponse implements IRegisterBodyTemperatureResponse {
    temperature!: number;

    constructor(data?: IRegisterBodyTemperatureResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.temperature = _data["temperature"] !== undefined ? _data["temperature"] : <any>null;
        }
    }

    static fromJS(data: any): RegisterBodyTemperatureResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterBodyTemperatureResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temperature"] = this.temperature !== undefined ? this.temperature : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IRegisterBodyTemperatureResponse extends IRegisterMeasurementResponse {
    temperature: number;
}

export class RegisterBodyTemperatureRequest extends RegisterMeasurementRequest implements IRegisterBodyTemperatureRequest {
    temperature!: number;

    constructor(data?: IRegisterBodyTemperatureRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.temperature = _data["temperature"] !== undefined ? _data["temperature"] : <any>null;
        }
    }

    static fromJS(data: any): RegisterBodyTemperatureRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterBodyTemperatureRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temperature"] = this.temperature !== undefined ? this.temperature : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IRegisterBodyTemperatureRequest extends IRegisterMeasurementRequest {
    temperature: number;
}

export class RegisterBloodPressureResponse extends RegisterMeasurementResponse implements IRegisterBloodPressureResponse {
    systolic!: number;
    diastolic!: number;

    constructor(data?: IRegisterBloodPressureResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.systolic = _data["systolic"] !== undefined ? _data["systolic"] : <any>null;
            this.diastolic = _data["diastolic"] !== undefined ? _data["diastolic"] : <any>null;
        }
    }

    static fromJS(data: any): RegisterBloodPressureResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterBloodPressureResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systolic"] = this.systolic !== undefined ? this.systolic : <any>null;
        data["diastolic"] = this.diastolic !== undefined ? this.diastolic : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IRegisterBloodPressureResponse extends IRegisterMeasurementResponse {
    systolic: number;
    diastolic: number;
}

export class RegisterBloodPressureRequest extends RegisterMeasurementRequest implements IRegisterBloodPressureRequest {
    systolic!: number;
    diastolic!: number;

    constructor(data?: IRegisterBloodPressureRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.systolic = _data["systolic"] !== undefined ? _data["systolic"] : <any>null;
            this.diastolic = _data["diastolic"] !== undefined ? _data["diastolic"] : <any>null;
        }
    }

    static fromJS(data: any): RegisterBloodPressureRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterBloodPressureRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["systolic"] = this.systolic !== undefined ? this.systolic : <any>null;
        data["diastolic"] = this.diastolic !== undefined ? this.diastolic : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IRegisterBloodPressureRequest extends IRegisterMeasurementRequest {
    systolic: number;
    diastolic: number;
}

export class RegisterBloodGlucoseResponse extends RegisterMeasurementResponse implements IRegisterBloodGlucoseResponse {
    level!: number;

    constructor(data?: IRegisterBloodGlucoseResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.level = _data["level"] !== undefined ? _data["level"] : <any>null;
        }
    }

    static fromJS(data: any): RegisterBloodGlucoseResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterBloodGlucoseResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level !== undefined ? this.level : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IRegisterBloodGlucoseResponse extends IRegisterMeasurementResponse {
    level: number;
}

export class RegisterBloodGlucoseRequest extends RegisterMeasurementRequest implements IRegisterBloodGlucoseRequest {
    level!: number;

    constructor(data?: IRegisterBloodGlucoseRequest) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.level = _data["level"] !== undefined ? _data["level"] : <any>null;
        }
    }

    static fromJS(data: any): RegisterBloodGlucoseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterBloodGlucoseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level !== undefined ? this.level : <any>null;
        super.toJSON(data);
        return data; 
    }
}

export interface IRegisterBloodGlucoseRequest extends IRegisterMeasurementRequest {
    level: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}